import { Box } from "@mui/material";
import { colors } from "../../../theme/muiColors";

export function highlightText(text: string, query: string) {
  const cleanQuery = query.trim();

  if (!cleanQuery) return text;

  const escapedQuery = cleanQuery.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`(${escapedQuery})`, "ig");
  const parts = text.split(regex);

  return parts.map((part, index) => {
    const isMatch = part.toLowerCase() === cleanQuery.toLowerCase();

    if (!isMatch) return part;

    return (
      <Box
        key={`${part}-${index}`}
        component="mark"
        sx={{
          px: 0.25,
          borderRadius: "4px",
          bgcolor: colors.orange[100],
          color: "inherit",
        }}
      >
        {part}
      </Box>
    );
  });
}
